import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/success.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-3568937e"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _createStaticVNode("<div class=\"payment-box\" data-v-3568937e><img src=\"" + _imports_0 + "\" alt=\"\" data-v-3568937e><p class=\"tip\" data-v-3568937e>信息绑定成功</p><div class=\"\" style=\"margin-top:2rem;\" data-v-3568937e><p class=\"info-content\" data-v-3568937e> 您的订单信息可在个人中心里查看我们会尽快进行检测，检测结果出来后系统会自动把检测报告发到您的邮箱。 </p></div></div>", 1);
var _hoisted_4 = { style: { display: 'flex', justifyContent: 'space-around' } };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("返回首页");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("叫快递");
import { ref } from "vue";
import { NavBar, Icon, Button } from "vant";
import { useRoute, useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BindingSuccess',
    setup: function (__props) {
        var route = useRoute();
        var router = useRouter();
        var loading = ref(false);
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "绑定成功",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(Button), {
                            class: "submit-btn",
                            style: _normalizeStyle({ marginTop: '0.32rem', border: '2px solid #fff' }),
                            color: "#3DABA4",
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(router).push('/salesman-personal-center')); })
                        }, {
                            default: _withCtx(function () { return [
                                _hoisted_5
                            ]; }),
                            _: 1
                        }, 8, ["style"]),
                        _createVNode(_unref(Button), {
                            class: "submit-btn",
                            style: _normalizeStyle({ marginTop: '0.32rem', border: '2px solid #fff' }),
                            color: "#3DABA4",
                            onClick: _cache[2] || (_cache[2] = function ($event) { return (_unref(router).push("/salesman-sending-express?orderId=" + _unref(route).query.orderId)); })
                        }, {
                            default: _withCtx(function () { return [
                                _hoisted_6
                            ]; }),
                            _: 1
                        }, 8, ["style"])
                    ])
                ])
            ]));
        };
    }
});
